type Roles = {
  [key: string]: string;
};
const roles: Roles = {
  ROLE_MENTEE: 'Mentee',
  ROLE_MENTOR: 'Mentor',
  ROLE_ADMIN: 'Admin',
  ROLE_GUEST: 'Guest',
};

function getAccountRole(role: string): string {
  return roles[role] || role;
}

export { getAccountRole };
